import "../styles/homepage.css";
import Sponsors from "./Sponsors/Sponsors";
import Facts from "./Facts/Facts"; // Imported the Facts component

export default function Home() {
  return (
    <div className="homepage">
      <section className="row1">
        <div className="column1">
          <h1 className="title">
            <span className="green">BRODKAST </span>
            <span className="white">NG </span>
            <span className="white">TALINO </span>
            <span className="green">2026 </span>
          </h1>
          <p>
            <b>Brodkast ng Talino</b> is an{" "}
            <b>Annual National Inter-Collegiate Electronic Systems and Technologies Quiz Show</b>{" "}
            organized by the Organization of Electronics Engineering Students (OECES) of the
            Technological University of the Philippines – Manila. Since its inception, Brodkast ng
            Talino has consistently gathered the brightest minds among Electronics Engineering
            students from various colleges and universities across the Philippines, fostering
            excellence in the field of Electronics and Communications Engineering.
          </p>
        </div>
        <div className="column2">
          <img src="pics/bnt.png" alt="Brodkast ng Talino Logo" className="bnt-img" />
        </div>
      </section>

      <div className="rows-combined">
        <section className="row2">
          <div className="column">
            <p>
              This year, Brodkast ng Talino elevates its legacy with its 11th edition, with a theme{" "}
              <b>"OVERTONE: Ascending to Greater Frequencies of Brilliance."</b> Building upon years
              of pioneering excellence, this edition transcends conventional competition in a fiercely
              engaging buzzer battle where contestants ignite a rapid-fire race of minds. Every buzz
              is a burst of intellect, and every answer propels them closer to victory. Engineered for
              those who think at the speed of brilliance. The competition is open to all bona fide
              undergraduate students of Electronics Engineering from any recognized college or
              university in the Philippines.
            </p>
          </div>
        </section>

        <section className="row3">
          <div className="column2">
            <img src="pics/oeces.png" alt="OECES Logo" className="oeces-img" />
          </div>
          <div className="column1">
            <p>
              The OECES is proud{" "}
              <b>to continue this tradition of promoting academic excellence and innovation</b>.
              Brodkast ng Talino serves as a platform not only to showcase technical expertise but
              also to inspire camaraderie and collaboration among future leaders in Electronics
              Systems and Technologies.{" "}
              <b>
                By participating in this event, students remain attuned to the latest technological
                advancements and share their knowledge with peers, contributing to the collective
                progress of the field in the modern era.
              </b>
            </p>
          </div>
        </section>
      </div>

      {/* --- FACTS SECTION ADDED HERE --- */}
      <Facts />

      {/* --- SPONSORS SECTION --- */}
      <Sponsors />
      
    </div>
  );
}